import { useDispatch } from "react-redux";
import React, { useEffect, useState } from "react";
import { showSnackBar } from "../Snackbar/Snackbar";
import { editCustomer } from "../../features/admin/adminSlice";
import Button from "../Button/Button";
import { NavLink } from "react-router-dom";
import { isEmptyFields } from "../../helpers/helper";

const ChangePasswordTab = () => {
  const dispatch = useDispatch();
  const [reqError, setReqError] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const currentURL = window.location.href;
  const parts = currentURL.split('/');
  const userId = parts[parts?.length - 1];

  useEffect(() => {
    const handleReqError = () => {
      reqError?.length > 0 && showSnackBar("error", reqError)
      setReqError('')
    }

    handleReqError()
  }, [reqError]);

  const handleEditCustomer = async () => {
    const response = await dispatch(editCustomer({ customerId: userId, userData: { password: newPassword } }));

    if (response.error) {
      setReqError(response.payload);
    } else if (response) {
      setNewPassword('')
      showSnackBar("success", "Your changes are saved");
    }
  };

  return (
    <div className="flex max-w-[850px] w-full">
      {/*<AddAvatar/>*/}
      <div className="w-full h-max shadow-card rounded-2xl p-6 ">
        <div className={` mt-6 pt-6 flex justify-end border-t border-divider`}>
          <NavLink to={"/"} >
            <Button classes={"mr-4"} onClick={() => { }} type="outlined" size="lg" width="min-w-[156px]">Close</Button>
          </NavLink>
          <NavLink to={`${isEmptyFields(newPassword) ? "/" : "/customers"}`} >
            <Button disabled={isEmptyFields(newPassword)} onClick={handleEditCustomer} size="lg" width="min-w-[156px]" classes="rounded-lg">Save</Button>
          </NavLink>
        </div>
      </div>
    </div>

  );
};
export default ChangePasswordTab